import styled from 'styled-components'

export const Directorbackground = styled.div`
background-image: url('');
height:80vh;
background-repeat:no-repeat;
background-size:cover;
background-position:center;
display:flex;
flex-direction:column;
`

export const Sub = styled.div`
padding:50px;
`

export const Directortext = styled.div`
color:white;
display:flex;
flex-direction: column;
align-self:center;
padding:200px;
// @media screen and (max-width: 768px) {
//     padding:0;
// }
`

export const Main = styled.div`
margin:0;
padding:0;
`